export const VALID_DISPLAY_STYLES = [
	'default',
	'new-year-promo',
	'white',
	'black',
] as const;

export type ValidDisplayStyle = (typeof VALID_DISPLAY_STYLES)[number];

export function normalizeDisplayStyle(
	style: string | undefined,
): ValidDisplayStyle {
	return (VALID_DISPLAY_STYLES as readonly string[]).includes(style ?? '')
		? (style as ValidDisplayStyle)
		: 'default';
}
